import type {
  JourneyCatalogEntry,
  JourneyDefinitionV1,
  JourneyId,
} from "@seeing-maths/contracts";
import mysteryNumber from "../../../content/journeys/ALG-001.json";
import catalogData from "../../../content/journeys/catalog.json";

export const journeyCatalog = catalogData as JourneyCatalogEntry[];
export const journeyDefinitions: Partial<Record<JourneyId, JourneyDefinitionV1>> = {
  "ALG-001": mysteryNumber as JourneyDefinitionV1,
};

export function getJourney(id: string): JourneyDefinitionV1 | null {
  return journeyDefinitions[id as JourneyId] ?? null;
}

export function getCatalogEntry(id: string): JourneyCatalogEntry | null {
  return journeyCatalog.find((entry) => entry.id === id) ?? null;
}
